export default {
    pinnedMsgs (state) {
      return state.pinnedMsgs
    },

    selectedPinnedMsg (state) {
        return state.selectedPinnedMsg
    },

    getPinnedMsg: state => (corpAdminMessageId) => {
      return state.pinnedMsgs().find(msg => msg.corpAdminMessageId === corpAdminMessageId)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/pinned/getters.js